import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDispatch, useSelector } from 'react-redux';
import { otpmessageSelector, otpmethodSelector, setGettingEmailOtpList, startVerifySecurityCode } from '../../../../Store/UsersAccount/userAccount.slice.selector';

const OTPInputBox = ({ onBack, buttonName, onNext, startAddVery }) => {
  const [otp, setOtp] = useState('');
  const otpmethodSelectordata = useSelector(otpmethodSelector)
  const otpSelectordata = useSelector(otpmessageSelector)
  const dispatch = useDispatch()

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleSubmit = () => {
    if (otp || otpmethodSelectordata) {
      const data = { otpmethodSelectordata , otp};
      // console.log('Dispatching:', data);
      dispatch(startVerifySecurityCode(data))
      // onNext();
    }
  };
// console.log(otpSelectordata, "otp selec")
  useEffect(() => {
      if (otpSelectordata === "otp successfull") {
        onNext();
      }
    }, [otpSelectordata])

  useEffect(() => {
      dispatch(setGettingEmailOtpList(""))
    }, [])

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
        <Button
          variant="outlined"
          color="secondary"
          sx={{
            border: 'none',
            '&:hover': {
              border: 'none',
            }
          }}
          onClick={onBack}
        >
          <ArrowBackIcon /> Back
        </Button>
      </Box>
      <Typography variant="h5" sx={{ fontWeight: '600', paddingBottom: "5px" }}>{buttonName}?</Typography>
      <Typography variant="h6" sx={{ marginTop: "3px", paddingBottom: "5px" }}>Enter the OTP</Typography>
      
      <TextField
        value={otp}
        onChange={handleOtpChange}
        label="OTP"
        variant="outlined"
        fullWidth
        sx={{ mt: 2, paddingBottom: "5px" }}
      />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          mt: 3,
          backgroundColor: "#f5365c",
          borderColor: "#f5365c",
          '&:hover': {
            backgroundColor: '#f5365c',
            color: 'white',
            border: 'none',
          }
        }}
        onClick={handleSubmit}>
        Submit
      </Button>
    </Box>
  );
};

export default OTPInputBox;
